import type { IVendor } from "../../../../types/models/vendor.modals.types";
import { usePostHttp } from "../../http.hook";

interface IBody {
  pan: string;
  fullName: string;
}

interface IResponse {
  vendor: IVendor;
}

export function useVerifyPanAdminHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/admin/vendors/:vendorId/pan",
  });
}
